export default __webpack_public_path__ + "static/media/civic health white2-04.dd011b7d.png";